// eslint-disable-next-line jira/restricted/react-component-props
import type { ComponentType, ComponentProps } from 'react';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { getBaseUrl } from '../../../state/selectors/base/index.tsx';
import type { State } from '../../../state/types.tsx';
import ReadyForUser from './view.tsx';

type ReadyForUserProps = JSX.LibraryManagedAttributes<
	typeof ReadyForUser,
	ComponentProps<typeof ReadyForUser>
>;

const mapStateToProps = (state: State) => ({ baseUrl: getBaseUrl(state) });

const ConnectedReadyForUser: ComponentType<ReadyForUserProps> = connect(
	mapStateToProps,
	{},
)(ReadyForUser);

export default ConnectedReadyForUser;
